import { PageConfig } from "@/types/types.ts";
import { StandardProps } from "@/components/componentMap.ts";
import { Entries } from "./Entries/Entries";
import { Groups } from "@/layouts/Slot/Groups/Groups.tsx";

type SlotProps = {
  name: string;
  pageConfig: PageConfig;
  className?: string;
  sizes: string;
  grouped?: boolean;
  componentGroupStyle?: string;
} & StandardProps;

export function Slot({
  name,
  className = "",
  pageConfig,
  sizes,
  grouped = false,
  componentGroupStyle,
  ...standardProps
}: SlotProps) {
  const slotEntries = pageConfig.slots[name];
  if (!slotEntries || slotEntries.length < 1) {
    return null;
  }

  return (
    <div className={className} data-slot={name} data-testid="slot">
      {grouped ? (
        <Groups
          groups={slotEntries}
          {...standardProps}
          sizes={sizes}
          className={componentGroupStyle}
        />
      ) : (
        <Entries components={slotEntries} {...standardProps} sizes={sizes} />
      )}
    </div>
  );
}
